// Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// 3rd party imports
import { plainToClass } from 'class-transformer';

// RxJs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Service imports
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';

// Model imports
import { WFSearchParameterDto } from '../_models/workflow-search/wf-search-parameter-dto';
import { WFSVendorSelectorParameterDto } from '../_models/workflow-search/wfs-vendor-selector-parameter-dto';
import { WFSVendorSelectorResultDto } from '../_models/workflow-search/wfs-vendor-selector-result-dto';
import { PropertyCommunityInfoParameterDto } from '../../_models/property-community-info-parameter-dto';
import { WorkflowSearchResultDto } from '../_models/workflow-search/workflow-search-result-dto';
import { SubmittedInvoiceResultDto } from '../_models/workflow-search/submitted-invoice-result-dto';

// constant imports
import { URLConstants } from '../../_constants/url-constants';
import { CacheDuration } from '../../_constants/cache-duration';

@Injectable({
    providedIn: 'root'
})
export class WorkflowSearchService {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly cacheRegistrationService: MPCacheRegistrationService
    ) {}

    getSearchVendors(baseParams: WFSVendorSelectorParameterDto): Observable<WFSVendorSelectorResultDto[]> {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}search/vendors${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };

        return this.httpClient
            .get(url, options)
            .pipe(map((response: any[]) => plainToClass(WFSVendorSelectorResultDto, response)));
    }

    getSearchDefaultBeginDate(baseParams: PropertyCommunityInfoParameterDto): Observable<Date> {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}search/defaultbegindate${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };

        return this.httpClient.get(url, options).pipe(map((response: any) => plainToClass(Date, response)));
    }

    getSearchInvoices(baseParams: WFSearchParameterDto): Observable<WorkflowSearchResultDto[]> {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}search${baseParams.getQueryString()}`;
        return this.httpClient.get(url).pipe(map((response: any[]) => plainToClass(WorkflowSearchResultDto, response)));
    }

    getMySubmittedInvoices(noOfDays: number): Observable<SubmittedInvoiceResultDto[]> {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}my-submitted-invoice?noOfDays=${noOfDays}`;
        return this.httpClient
            .get(url)
            .pipe(map((response: any[]) => plainToClass(SubmittedInvoiceResultDto, response)));
    }
}
